import { render, staticRenderFns } from "./commandes.vue?vue&type=template&id=31c26a1a&scoped=true&"
import script from "./commandes.vue?vue&type=script&lang=js&"
export * from "./commandes.vue?vue&type=script&lang=js&"
import style0 from "./commandes.vue?vue&type=style&index=0&id=31c26a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c26a1a",
  null
  
)

export default component.exports